export default __webpack_public_path__ + "static/media/banners_2.53da4518.png";